import
  React
from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  CustomColors,
  Icons
} from '../../constants';

import {
  Modal,
  SecondaryButton
 } from 'components';

 import {
  HandleRender,
  withScreenViewTagging
} from 'hocs';

import {
  ColorSvg,
  Text,
  VContainerH,
  VContainerVH
} from '@vodacom/web-common';

const Card = styled(VContainerH)`
  z-index: 5;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const Content = styled(Text)`
  color:${CustomColors.Grey11};
  p {
    margin: 0;
  }
  img {
    max-width: 100%;
  }
  text-align: center;
`;

export const ModalCardUI = props => {

  ModalCardUI.pageName = props.pageName;

  ModalCardUI.tagViewData = {
    ...props.tagViewData,
    page_section: props.pageSection
  };

  const renderCardContent = () => {

    return (

      <VContainerVH>

        { props.customContent &&

          <Content
            fontSize={'14px'}
            color={CustomColors.Grey11}
            dangerouslySetInnerHTML={{
              __html: props.customContent
            }}/>
        }

        { !props.customContent &&
          <>
            <ColorSvg
              src={props.isSuccess ? Icons.CheckmarkCircle : Icons.WarningTriangle}
              color={props.isSuccess ? CustomColors.Green5 : CustomColors.Red2}
              height={props.iconHeight}
              width={props.iconWidth}
              margin={props.iconMargin} />

            {
              props.title &&
              <Text
                fontSize={props.titleFontSize}
                fontWeight={'bold'}
                textAlign={'center'} >

                {props.title}
              </Text>
            }
          </>
        }

        <Text
          font-family={props.messageFontFamily}
          fontSize={props.messageFontSize}
          fontWeight={props.messageWeight}
          color={CustomColors.Grey9}
          textAlign={'center'}
          padding={'16px 0'}
          whiteSpace={'pre-wrap'}>

          {props.message}
        </Text>

        <SecondaryButton
          text={props.buttonText}
          margin={'15px 0 0'}
          onClick={props.onClose}/>

      </VContainerVH>
    );
  };

  return (
    <>
      <Modal
        onClose={props.onClose}/>

      <Card
        backgroundColor={CustomColors.White}
        borderRadius={props.borderRadius}
        padding={props.padding}
        maxWidth={props.maxWidth}
        boxSizing={'border-box'}
        width={props.width}>

        <HandleRender
          isLoading={props.isLoading}>

          {renderCardContent()}
        </HandleRender>
      </Card>
    </>
  );
};

ModalCardUI.propTypes = {
  padding: PropTypes.string,
  customContent: PropTypes.string,
  isSuccess: PropTypes.bool.isRequired,
  iconHeight: PropTypes.string,
  iconWidth: PropTypes.string,
  iconMargin: PropTypes.string,
  title: PropTypes.string,
  titleFontSize: PropTypes.string,
  message: PropTypes.string,
  messageFontFamily: PropTypes.string,
  messageWeight: PropTypes.string,
  messageFontSize: PropTypes.string,
  buttonText: PropTypes.string,
  pageSection: PropTypes.string,
  tagViewData: PropTypes.object,
  pageName: PropTypes.string.isRequired,
  maxWidth: PropTypes.string,
  width: PropTypes.string,
  borderRadius: PropTypes.string,
  isLoading: PropTypes.bool
};

ModalCardUI.defaultProps = {
  padding: '16px 50px 26px',
  customContent: '',
  isSuccess: true,
  iconHeight: '67px',
  iconWidth: '67px',
  iconMargin: '',
  title: undefined,
  titleFontSize: '24px',
  message: '',
  messageFontFamily: 'inherit',
  messageWeight: 'bold',
  messageFontSize: '16px',
  buttonText: 'Close',
  pageSection: 'emergency sms',
  tagViewData: {},
  maxWidth: '350px',
  width: '92%',
  borderRadius: '4px',
  isLoading: false
};

export const ModalCard = withScreenViewTagging(ModalCardUI);